// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.detail-channel .el-input.is-disabled .el-input__inner,\n.detail-channel .el-textarea.is-disabled .el-textarea__inner {\n  color: #727c8a !important;\n}\n", ""]);
// Exports
module.exports = exports;
